import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// v-query forces browser cache refresh when logo asset changes
export const LOGO_URL = "/gens-realty-logo.jpg?v=20260208";

// HAR.com IDX-AWS company id
export const HAR_CID = "537207";
export const HAR_BASE = "https://www.har.com/idx";

export const formatPrice = (n) => {
  if (n === undefined || n === null) return "";
  if (n >= 1000000) return `$${(n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 2)}M`;
  if (n >= 1000) return `$${(n / 1000).toFixed(0)}K`;
  return `$${n.toLocaleString()}`;
};

export const fullPrice = (n) =>
  n === undefined || n === null ? "" : `$${n.toLocaleString()}`;
